import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {
  Button,
  Layout,
  Upload,
  Icon,
  Drawer,
  Radio,
  Menu,
  Form,
  Input,
  Select,
  ConfigProvider,
  Dropdown,
  DatePicker,
  Badge,
  Tabs,
  Spin,
  List,
  Avatar,
  Table,
  Tooltip,
  Tag,
  Checkbox,
  Card,
  Col,
  Row,
  Popover,
  Progress,
  Alert,
  message,
  notification,
  Pagination,
  Popconfirm,
  FormModel,
  Divider
} from "ant-design-vue";
import Authorized from "./components/Authorized";
import Auth from "./directives/auth";
import ref from "vue-ref";
Vue.use(ref, { name: "ant-ref" });

import Storage from "vue-ls";

const options = {
  namespace: "KA__", // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local" // storage name session, local, memory
};

Vue.use(Storage, options);
Vue.config.productionTip = false;

Vue.use(Button);
Vue.use(Layout);
Vue.use(Icon);
Vue.use(Drawer);
Vue.use(Upload);
Vue.use(Radio);
Vue.use(Menu);
Vue.use(Form);
Vue.use(Input);
Vue.use(Select);
Vue.use(ConfigProvider);
Vue.use(Dropdown);
Vue.use(DatePicker);
Vue.use(Avatar);
Vue.use(Tooltip);
Vue.component("Authorized", Authorized);
Vue.use(Auth);
Vue.use(Badge);
Vue.use(Tabs);
Vue.use(Spin);
Vue.use(List);
Vue.use(Tag);
Vue.use(Checkbox);
Vue.use(Card);
Vue.use(Col);
Vue.use(Row);
Vue.use(Popover);
Vue.use(Progress);
Vue.use(Alert);
Vue.use(Table);
Vue.use(Pagination);
Vue.use(Popconfirm);
Vue.use(Divider);
Vue.use(FormModel);
Vue.use(VueQuillEditor);
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
